export const MaterialTypes = {
    materialUI: 'materialUI',
    custom: 'custom',
}